<template>
  <div :class="[locale, 'page-wrap']">
    <Header v-if="!layoutCustomProps.isHide"></Header>
    <div class="page-content">
      <slot></slot>
    </div>
    <Footer v-if="!layoutCustomProps.isHide"></Footer>
  </div>
</template>

<script setup lang="ts">
import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";

const layoutCustomProps = useAttrs()
const { locale } = useI18n();
</script>

<style>
.page-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
  display: flex;     
  flex-direction: column; 
}
</style>
